import { FormattedMessage } from 'react-intl';

// assets
import { ReadOutlined, ContactsOutlined, BankOutlined, AuditOutlined, ProfileOutlined } from '@ant-design/icons';

// icons
const icons = {
  ContactsOutlined,
  BankOutlined,
  AuditOutlined,
  ProfileOutlined,
  ReadOutlined
};

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const contacts = {
  id: 'contacts_parent',
  title: '',
  type: 'group',
  children: [
    {
      id: 'demandes',
      title: <FormattedMessage id="menu-items.demandes" />,
      icon: icons.ContactsOutlined,
      url: '/demandes',
      type: 'item'
    },
    {
      id: 'commandes',
      title: <FormattedMessage id="menu-items.commandes" />,
      icon: icons.ContactsOutlined,
      url: '/commandes',
      type: 'item'
    },
    {
      id: 'inventaire',
      title: <FormattedMessage id="menu-items.inventaire" />,
      icon: icons.BankOutlined,
      url: '/inventaire',
      type: 'item'
    },
    {
      id: 'finance',
      title: <FormattedMessage id="menu-items.finance" />,
      icon: icons.BankOutlined,
      type: 'item',
      url: '/invoices'
    }
  ]
};

export default contacts;
